// extracted by mini-css-extract-plugin
export default {"accountContainer":"Account_accountContainer__c1tjV","formContainer":"Account_formContainer__tRYrl","divider":"Account_divider__VyHI-","maiImg":"Account_maiImg__OAFRg"};